import OpenAI from "openai";
import {ChatCompletionMessageToolCall} from "openai/src/resources/chat/completions";
import {v4 as uuidv4} from "uuid";

const threadStore = new Map<string, OpenAI.ChatCompletionMessageParam[]>()
/**
 *
 */
export const createThread = async (): Promise<string> => {

    const newThreadId = "thread_" + uuidv4()

    threadStore.set(newThreadId, [])

    return newThreadId

}
const addToThreadStore = (message: OpenAI.ChatCompletionMessageParam, threadId: string) => {

    if (!threadStore.has(threadId)) {
        throw new Error("Thread not found: " + threadId)
    }

    threadStore.get(threadId)?.push(message)
}
export const getMessagesFromThreadStore = (threadId: string, truncation = 100): OpenAI.ChatCompletionMessageParam[] => {
    if (!threadStore.has(threadId)) {
        throw new Error("Thread not found: " + threadId)
    }

    const messages = threadStore.get(threadId)

    return messages ? messages.slice(-truncation) : []
}
export const addMessageToThread = async (
    content: string | null,
    threadId: string,
    role: 'user' | 'assistant' | 'tool' = 'user',
    tool_calls: ChatCompletionMessageToolCall[] | null = null,
    tool_call_id: string | null = null
) => {

    let message = {
        content: content,
        tool_calls: tool_calls,
        role: role
    } as OpenAI.ChatCompletionUserMessageParam | OpenAI.ChatCompletionAssistantMessageParam | OpenAI.ChatCompletionToolMessageParam

    if (role === "tool" && tool_call_id) {
        message = (message as OpenAI.ChatCompletionToolMessageParam)
        message.tool_call_id = tool_call_id
    }

    addToThreadStore(message, threadId)

    // console.info('added to %s %o', threadId, message)
};
